import { observable, computed, action, IObservableArray } from "mobx";

import { CollectionTreeViewStoreBase } from "./CollectionTreeViewStoreBase";
import { CollectionStoreImpl } from "./CollectionStore";
import { NotificationStore } from "./NotificationStore";
import * as DocumentManagement from "../DocumentManagement";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";


export class CollectionAsideTreeViewStore extends CollectionTreeViewStoreBase {

	constructor(collectionStore: CollectionStoreImpl) {
		super(collectionStore);
	}

	//Resolve all root collections.
	@action getRoots() {
		DocumentManagement.getRootCollectionsAsync().then(result => {
			this.model.subCollections.replace(result);
			this.resolveTreePathCollections(this.model);
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}


}